import type { NavigationRailItem } from "@/toggle-ui-kit/navigation-rail";
import type { ComponentType } from "react";
import { DSD_REVIEW_COPY } from "../copy";
import {
  CompanyNameIcon,
  NoteMatchingIcon,
  SpellIcon,
  SumIcon,
} from "./mode-icons";
import type {
  DsdEditorReviewMode,
  DsdReviewRailAvailability,
  DsdReviewRailCounts,
} from "./rail-counts";

const MODES: {
  mode: DsdEditorReviewMode;
  Icon: ComponentType<{ className?: string }>;
  /** 베타에서만 보이는 모드 */
  betaOnly?: boolean;
}[] = [
  { mode: "note-reference-review", Icon: NoteMatchingIcon },
  { mode: "note-note-matching", Icon: NoteMatchingIcon, betaOnly: true },
  { mode: "sum-validation", Icon: SumIcon },
  { mode: "corrections", Icon: SpellIcon },
  { mode: "company-name-review", Icon: CompanyNameIcon },
];

/**
 * rail 항목. 고를 수 없는 모드엔 사유를 툴팁으로 단다 —
 * 오탈자 분석이 도는 중이면 교정은 "진행 중", 그 밖엔 "결과 없음".
 */
export const getDsdReviewRailItems = ({
  counts,
  availability,
  correctionPending,
}: {
  counts: DsdReviewRailCounts;
  availability: DsdReviewRailAvailability;
  correctionPending: boolean;
}): NavigationRailItem<DsdEditorReviewMode>[] =>
  MODES.map(({ mode, Icon, betaOnly }) => {
    const disabled = !availability[mode];
    return {
      id: mode,
      label: DSD_REVIEW_COPY.rail[mode],
      Icon,
      count: counts[mode],
      disabled,
      betaOnly,
      tooltip: !disabled
        ? undefined
        : mode === "corrections" && correctionPending
          ? DSD_REVIEW_COPY.rail.correctionPending
          : DSD_REVIEW_COPY.rail.noData,
    };
  });
